import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import { SplitButton,Dropdown,Button,ButtonToolbar,DropdownButton, NavDropdown} from 'react-bootstrap';
import * as TgccRequest from '../tgccRequest';
import { RealCampusMenuItem } from '../Components/RealCampusMenuItem';

const containerStyle: React.CSSProperties = {
    height:'100px',
    width:'100%',
    textAlign:'center'
};
const navItemStyle: React.CSSProperties = {
    fontFamily:'BarlowMedium',
    marginRight:'40px',
    cursor:'pointer',
    color:'white',
    backgroundColor:'#5E6A74',
    ':hover':{
        color:'#c2b186'
    }
}
const navItemBtnHome = Object.assign({},navItemStyle,{display:'none'});
const navItemShop : React.CSSProperties = {
    fontFamily:'BarlowMedium',
    cursor:'pointer',
    color:'white',
    backgroundColor:'#5E6A74',
    ':hover':{
        color:'#c2b186'
    }
}
const navBar: React.CSSProperties = {
    display:'flex',
    alignSelf:'center',
    flexDirection:'row',
    flexWrap:'wrap',
    justifyContent:'center',
    alignItems:'center'
}
const topNav: React.CSSProperties = {
    width:'100%',
    backgroundColor:'white',
    height:'75px',
    display:'flex',
    flexDirection:'row',
    justifyContent:'space-around',
    position:'fixed',
    zIndex:2,
    border:'1px solid #e9e6e6'
}
const topNavStyle: React.CSSProperties = {
    height:'40px',
    margin:'13px 10px',
    lineHeight:'38px',
    padding:'5px',
    fontFamily:'BarlowMedium',
    cursor:'pointer',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    color:'#5E6A74'
}
const loggedIn : React.CSSProperties = {
    position:'absolute',
    right:'3%',
    top:'50px',
    fontFamily:'BarlowLight'
}
const mobileLogIn : React.CSSProperties = {
    fontFamily:'BarlowLight'
}

const imgFile = Tgcc.ResolveUrl('~/images/Real_Campus_Logo.png');

const imgStyles : React.CSSProperties ={
    cursor:'pointer',
    width:'350px',
};
const txt: React.CSSProperties = {
    fontFamily:"AveriaSerifLightItalic",
    marginLeft:'20px',
}
const logoTxt: React.CSSProperties = {
    display:'flex',
    alignItems:'center'
}
const rightNav: React.CSSProperties = {
    display:'flex',
}

const emailStyle: React.CSSProperties = {
    fontFamily:'BarlowMedium'
}
const mobileContainer: React.CSSProperties = {
    display:'flex',
    justifyContent:'space-between',
    alignItems:'center',
    color:'#5E6A74'
}
const rc_dropdown: React.CSSProperties = {
    fontFamily:'BarlowMedium',
    color:'#5E6A74'
}
const mbNavItem: React.CSSProperties = {
    color:'#5E6A74'
}
const mobileLogCont: React.CSSProperties =  {
    fontFamily:'BarlowMedium',
    color:'#5E6A74',
    display:'flex',
    flexDirection:'column',
    marginRight:'5px',
    alignItems:'flex-end'
}
const division: string = 'realcampus';

const topLoginStyle = Object.assign({}, topNavStyle, {margin: '13px 10px 20px'});
class _RealCampusHdr extends React.Component <Tgcc.BaseProps, any > {

    openDashboard = () => {browserHistory.push(Tgcc.Routes.RealCampusDashboard)};
    openCSR = () => {browserHistory.push(Tgcc.Routes.CSR)};
    openDesign = () => {browserHistory.push(Tgcc.Routes.RealCampusDesignView)};
    openCampus = () => {browserHistory.push(Tgcc.Routes.RealCampusHome)};
    openContact = () => {browserHistory.push(Tgcc.Routes.CampusContact)}
    openHowItWorks = () =>{browserHistory.push(Tgcc.Routes.CampusHowItWorks)};

   
    openProducts = () => {browserHistory.push(Tgcc.Routes.RealCampusProductListView)};
    openRegister = () =>{browserHistory.push(Tgcc.Routes.RealCampusRegister)}
    openMerch = () => {browserHistory.push(Tgcc.Routes.RealCampusSchools)}
    loginUser = () => {
        browserHistory.push(Tgcc.Routes.RealCampusLogin) 
    }

    logoutUser = () => {
        Tgcc.LogoutRealCampusUser(this.props.dispatch, this.props.state.LoginData);
                this.props.dispatch({type:Tgcc.StateAction.ForwardLocation, payload:this.props.state.ActiveProof});

            this.props.dispatch({type:Tgcc.StateAction.ForwardLocation, payload:this.props.state.ActiveProof});
    }
    componentDidMount(){
        TgccRequest.getMerchandisingThemes(division,(themes:Tgcc.MerchandisingTheme[]) => this.loadThemes(themes))
    }
    loadThemes = (themes: Tgcc.MerchandisingTheme[]) => {
        this.setState({Themes:themes})
    }

    getLoginLink(){
        if(this.props.state.LoginData){
            return <div style={topLoginStyle} className="logStyle" key={1} onClick={this.logoutUser}>Logout</div>
        }
        return <div  style={topLoginStyle} className="logStyle" key={2} onClick={this.loginUser}>Login</div>
    }
    getDashboardLink(){
        if(!this.props.state.LoginData){
            return <div style={topNavStyle} key={3} className="acctStyle" onClick={this.openRegister}>Create Account</div>
        }
        return <div style={topNavStyle} key={4} className="acctStyle" onClick={this.openDashboard}>My Account</div>
    }
    getMobileLoginLink(){
        if(this.props.state.LoginData){
            return <div key={1} onClick={this.logoutUser}>Logout</div>
        }
        return <div key={2} onClick={this.loginUser}>Login</div>
    }
    getMobileDashboardLink(){
        if(!this.props.state.LoginData){
            return <div key={3} onClick={this.openRegister}>Create Account</div>
        }
        return <div key={4} onClick={this.openDashboard}>My Account</div>
    }
    getUserName(){
        if(this.props.state.LoginData && this.props.state.LoginData.impersonate)
            return <div style={loggedIn}>Impersonating: {this.props.state.LoginData.impersonate}</div>
            
        if(this.props.state.UserInfo && this.props.state.UserInfo.email)
            return <div style={loggedIn} className='realloggedStyle'>Logged in as: <span style={emailStyle}>{this.props.state.UserInfo.email}</span></div>
    }
    getMobileUserName (){
        if(this.props.state.UserInfo && this.props.state.UserInfo.email)
        return <div style={mobileLogIn}>Logged in as: <span style={emailStyle}>{this.props.state.UserInfo.email}</span></div>
}
    openProofEdit = () => {
            browserHistory.push(Tgcc.Routes.RealCampusProofEdit)
    };
    requestSchool = () => {
        browserHistory.push(Tgcc.Routes.RealCampusSchoolRequest)
    };
    onClick = (theme:Tgcc.MerchandisingTheme) => {
        browserHistory.push(Tgcc.Routes.RealCollection(theme.theme))
        document.dispatchEvent(new MouseEvent('click'));

    }

    getSchoolHdrList = () => {
        var hdrList = new Array();
        for(var x in this.state.Themes){
            var school: Tgcc.MerchandisingTheme = this.state.Themes[x]
            hdrList.push(<RealCampusMenuItem key={school.id} theme={school} onCallback={this.onClick} title={school.title} />);
        }
        return hdrList;
    }
    render() {
        var logLink = this.getLoginLink();
        var dbLink = this.getDashboardLink();
        var moblogLink = this.getMobileLoginLink();
        var mobdbLink = this.getMobileDashboardLink();
            if(window.innerWidth <= 440){
                return(<div style={mobileContainer}>
                    <ButtonToolbar> 
                        <NavDropdown
                            title="MENU"
                            id="dropdown-no-caret-rc"
                            style={rc_dropdown}>
                            <Dropdown.Item eventKey="101" onClick={this.openCampus}>HOME</Dropdown.Item>
                            <Dropdown.Item eventKey="102" onClick={this.openDesign}>THE DESIGN BOARD</Dropdown.Item>
                            <Dropdown.Item eventKey="103" onClick={this.openProofEdit}>START AN ORDER</Dropdown.Item>
                            <NavDropdown id={'basic-nav-dropdown-2'} title="SHOP YOUR SCHOOL">
                            {this.getSchoolHdrList()}
                                <Dropdown.Item/>
                             <Dropdown.Item eventKey='1' onClick={this.requestSchool}>Request Your School</Dropdown.Item>                      
                   </NavDropdown>
                            <Dropdown.Item eventKey="104" onClick={this.openProducts}>APPAREL</Dropdown.Item>
                        </NavDropdown>
                    </ButtonToolbar>
                    <div style={mobileLogCont}>
                        {moblogLink}
                        {mobdbLink}
                        {this.getMobileUserName()}
                        </div>
                    </div>             
                )
            } else {
                return (
            <div style={containerStyle}>
                <div style={topNav} className="realTopNav">
                <div onClick={this.openCampus} style={logoTxt} className="campusNvLogo">
                            <img src={imgFile} style={imgStyles}/>
                    </div>
                <div style={navBar} className="realLeftNav">
                <Button key={98}  style={navItemBtnHome}  className="realNavBtnHome" onClick={this.openProofEdit}>HOME</Button>
                <SplitButton id={'split-button-basic-1'} style={navItemShop} className="realNavBtn" title="SHOP YOUR SCHOOL" key={94} onClick={this.openMerch}>
                        {this.getSchoolHdrList()}
                        <Dropdown.Item/>
                        <Dropdown.Item eventKey='1' onClick={this.requestSchool}>Request Your School</Dropdown.Item>                      
                   </SplitButton>
                 <Button key={97}  style={navItemStyle}  className="realNavBtn" onClick={this.openProofEdit}>START AN ORDER</Button>
                 <Button key={95}  style={navItemStyle}  className="realNavBtn" onClick={this.openProducts}>APPAREL</Button>
                 <Button key={96}  style={navItemStyle}  className="realNavBtn" onClick={this.openDesign}>THE DESIGN BOARD</Button>             
                </div>
                <div style={rightNav} className="logNav">
                    {logLink}
                    {dbLink}
                </div>
                {this.getUserName()}
                
                </div>            
              
            </div>
        )
                }
    }
    
}
const mapStateToProps = (state: Tgcc.GlobalState) => {
    return { 
        state: state,
    };
};

export var RealCampusHdr = connect(mapStateToProps)(Radium(_RealCampusHdr));